import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import axio from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'
import Loading from '../../components/Loading'
import { projectContext, loadingContext, urlValue, unfolder, onImportExcelAsync, closeModalVw, openModalVw, openAlert, downloadFile, encrypter, useTranslate } from '../../lib'
import '../../styles/settings.scss'
import '../../styles/settingsOptions.scss'
import { customModal } from '../../styles/customModal'
import TitleBar from "../../components/TitleBar";
import '../../styles/styles.css'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import CheckBox2 from '../../components/CheckBox2'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import SettingsOptionsGenAI from '../../components/ProjectGenAI/SettingsOptionsGenAI'
import SideBarGenAI from '../../components/ProjectGenAI/SideBarGenAI'
import { Alerts } from '../../components/common/Alerts'
import { SelectNesting } from '../../components/common/Inputs/Select'

export default function SettingsGenAI() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [clients, setClients] = useState([])
  const [isModalOpenTypeUser, setIsModalOpenTypeUser] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [isModalOpenUserStudio, setIsModalOpenUserStudio] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [usersDelete, setUsersDelete] = useState([]);
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [selectedRadio, setSelectedRadio] = useState('TP');
  const [modalGuest, setMdGuest] = useState(false);
  const [roleUser, setRoleUser] = useState(1)
  const [role, setRole] = useState(0);
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/client-project/${selectedProject.id}`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        setClients(response.data.clients)
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
      })
  }, [refresh])

  function openModal(modal, client) {
    setValue('id', null)
    setValue('name', null)
    if (modal === 'new') {
      setIsModalOpen({ ...isModalOpen, new: true })
    } else {
      setSelectedClient(client)
      if (modal === 'edit') {
        // setIsModalOpen({ ...isModalOpen, edit: true })
        openModalVw("#edituser-md", () => setIsModalOpen({ ...isModalOpen, edit: true }))
        setValue('id', client.ccms_id)
        setValue('name', client.ccms_name)
        setValue('max_multichat', client.max_multichat)
        setValue('gender_avatar', client.gender_avatar)
      } else {
        // setIsModalOpen({ ...isModalOpen, delete: true })
        openModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: true }))
      }
    }
  }

  const onSubmitDelete = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/client-project`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        const id = response.data.filter(value => {
          if (
            value.project_id === selectedProject.id &&
            value.client_id === selectedClient.id
          ) {
            return value
          }
        })[0].id
        axios({
          method: 'post',
          url: `${urlValue}/studio/client-project/${id}/delete`,
          headers: {
            'access-token': token,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
        })
          .then(function (response) {
            setLoading(false)
            setIsModalOpen({ ...isModalOpen, delete: false })
            setRefresh(!refresh)
          })
          .catch(function (error) {
            setLoading(false)
            setIsModalOpen({ ...isModalOpen, delete: false })
            setRefresh(!refresh)
          })
      })
      .catch(function (error) {
        setLoading(false)
      })
  }

  const onSubmitNewStudio = data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    console.log("dataStudio", data, roleUser)
    const data2 = JSON.stringify({
      ccms_id: data.ccms_id_studio,
      ccms_name: data.ccms_name_studio,
      role: roleUser,
      project: selectedProject.id
    })
    const encry = encrypter(data2, 'IANestingKey')

    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/user`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {"usuario": encry},
    })
      .then(function (response) {
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
          () => { setAlert({ ...alert, visible: false }) });
        setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false })
        setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false })
        setLoading(false)
        setRefresh(!refresh)
      })
      .catch(function (error) {
        console.log("error created user studio", error)
        setLoading(false)
      })
  }

  const onSubmitNew = data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    
    const data2 = JSON.stringify({
      ccms_id: data.id,
      ccms_name: data.name,
      max_multichat: data.max_multichat,
      multiple: false,
      project: selectedProject.id,
      gender_avatar: data.gender_avatar
    })
    const encry = encrypter(data2, 'IANestingKey')
    
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {"usuario": encry},
    })
      .then(function (response) {
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
          () => { setAlert({ ...alert, visible: false }) });
        postClientProject(response.data.client.id, true)
      })
      .catch(function (error) {
        getIdClientByCcmsId(data.id).then(id => postClientProject(id, true))
      })
  }

  const onSubmitEdit = async data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client/${selectedClient.id}/update`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        ccms_id: data.id,
        ccms_name: data.name,
        max_multichat: data.max_multichat,
        gender_avatar: data.gender_avatar,
      },
    })
      .then(function (response) {
        setLoading(false)
        setIsModalOpen({ ...isModalOpen, edit: false })
        setRefresh(!refresh)
      })
      .catch(function (error) {
        setLoading(false)
        setIsModalOpen({ ...isModalOpen, edit: false })
      })
  }

  const postClientProject = (clientId, load) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    axios({
      method: 'post',
      url: `${urlValue}/studio/client-project`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        project_id: selectedProject.id,
        client_id: clientId,
      },
    })
      .then(function (response) {
        if (load) {
          setIsModalOpen({ ...isModalOpen, new: false })
          setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false })
          setLoading(false)
          setRefresh(!refresh)
        }

      })
      .catch(function (error) {
        if (load) {
          setIsModalOpen({ ...isModalOpen, new: false })
          setLoading(false)
        }
      })
  }

  const getIdClientByCcmsId = async (ccmsId, load) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    return await axios({
      method: 'get',
      url: `${urlValue}/studio/client`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        if (load) setLoading(false)
        return response.data.filter(value => {
          if (value.ccms_id === ccmsId) {
            return value
          }
        })[0].id
      })
      .catch(function (error) {
        if (load) setLoading(false)
      })
  }

  const submitNew = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    const ccms_id = document.querySelector("#ccms_id").value;
    const ccms_name = document.querySelector("#ccms_name").value;
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client`,
      headers: {
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        ccms_id: ccms_id,
        ccms_name: ccms_name
      },
    })
      .then(function (response) {
        postClientProject(response.data.client.id, true)
      })
      .catch(function (error) {
        getIdClientByCcmsId(ccms_id, true).then(id => postClientProject(id, true))
      })
  }



  // const [UsersExcel, setUsersExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)

  const uploadMaxive = async (UsersExcel) => {

    if (!loadingUpload && UsersExcel.length > 0 && UsersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        setLoading(true)
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

        for (var i = 0; i < UsersExcel.length; i++) {
          const data = {
            ccms_id: UsersExcel[i].CCMS_ID.toString().trim(),
            ccms_name: UsersExcel[i].CCMS_NAME.toString().trim(),
            max_multichat: 5,
            project: selectedProject.id,
            multiple: true
          }

          const encry = encrypter(data, 'IANestingKey')

          try {
            const rest = await axios.post(`${urlValue}/studio/client`, {"usuario": encry}, {
              headers: {
                'access-token': token,
                'X-CSRF-Token': csrfToken
              },
              withCredentials: true,
            });
            if (rest.status === 200) {
              const restCp = await axios.post(`${urlValue}/studio/client-project`, {
                project_id: selectedProject.id,
                client_id: rest.data.client.id,
              },
              { 
                headers: { 
                  user: id, 
                  'access-token': token, 
                  'X-CSRF-Token': csrfToken
                },
                withCredentials: true,
              })


            } else {
              await getIdClientByCcmsId(UsersExcel[i].CCMS_ID.toString().trim(), false).then(id => postClientProject(id, false))
            }
          } catch (error) {
            await getIdClientByCcmsId(UsersExcel[i].CCMS_ID.toString().trim(), false).then(id => postClientProject(id, false))
          }


        }
        setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false })
        window.location.reload();
      }, 1000)

    } else {
      alert(t('alerts.intentExcelLimit'))

    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file, ['CCMS_ID', 'CCMS_NAME']);

    uploadMaxive(DatosExcel);

  }


  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#users-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#users-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }

  const deleteMultiple = async () => {
    try {
      if (usersDelete.length > 0) {
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let result;
        for (let i = 0; i < usersDelete.length; i++) {
          const resp = await axios({
            method: 'get',
            url: `${urlValue}/studio/client-project`,
            headers: { 'access-token': token, },
          })
          const id = resp?.data.filter(value => {
            if (
              value.project_id === selectedProject.id &&
              value.client_id === usersDelete[i].id
            ) {
              return value
            }
          })[0]?.id
          await axios({
            method: 'post',
            url: `${urlValue}/studio/client-project/${id}/delete`,
            headers: {
              'access-token': token,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
          })
        }
      }
    } catch (error) {
      console.log(error)
      // setModalDelete(false)
    } finally {
      closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))
      // setModalDelete(false)
      window.location.reload();
    }
  }

  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setUsersDelete([...usersDelete, item])
    } else {
      setUsersDelete(usersDelete.filter(x => x.id !== item.id));
    }
  }

  function getSelectedRadioValue(e) {
 
    if (selectedRadio === 'TP') {
      openModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: true }))
    } 
    else if (selectedRadio === 'Studio') {
      openModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: true }))
    }    
    else {
      openModalVw("#guest-md", () => setMdGuest(true))
    }

  }


  return (
    <>
      <section className="container-settings general-container" id="container">
        <SideBarGenAI active={'Settings'} />
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="container-info w-100 d-flex flex-row flex-wrap justify-space-between">
            <div className="d-flex flex-row align-items-center flex-wrap justify-space-between w-100">
              <div className="title d-flex flex-row align-items-center ml-2" style={{ whiteSpace: "nowrap" }}>
                <div>
                  <h2>{selectedProject.name}</h2>
                </div>
                <div className="p-1 separator">-</div>
                <div>
                  <h1>{t('common.settings')}</h1>
                </div>
              </div>
            </div>

            <div className="container-edit settings-c">

              <SettingsOptionsGenAI 
                role={role} setRole={setRole}
              />

            </div>
            {/**
            <div className="body pt-1 account-container account-c" style={{ backgroundColor: '#F9F9F9', borderRadius: 25 }}>
              <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18 }}>Account Management</h2>


              <div className="pl-3 d-flex flex-row align-items-center justify-space-between">
                <div className=" head w-100 ">

                  <div className="search " >
                    <input
                      type="text"
                      placeholder="Search User"
                      onChange={event => {
                        setSearch(event.target.value)
                      }}
                      style={{width:'80%', fontSize:'14px'}}
                    />
                    <img src="/icons/search.svg" />
                  </div>
                  <div className="flex flex-1 items-center  jsutify-end">
                    <div id="adduser-btn" className="ml-2 btn-top btn-top-new newProject" onClick={() => openModalVw("#typeuser-md", () => setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: true }))} style={{ backgroundColor: '#0038A8' }}>
                      <span className='' style={{ color: 'white !important' }}>Add User</span>
                      
                      <Tooltip  anchorSelect="#adduser-btn" content={`Add new user to the project`} place="top" />
                    </div>
                    <div onClick={() => openModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: true }))} className="ml-2 btn-top btn-top-delete newProject" style={{ backgroundColor: '#0038A8' }}>
                      <span className='' style={{ color: 'white !important' }}>Delete</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="titles mt-3 d-flex flex-row w-100" style={{ justifyContent: 'space-between' }}>
                <div className="name">
                  <div style={{ color: "#0087FF" }}>NT User</div>
                </div>
                <div className="id">
                  <div style={{ color: "#0087FF" }}>BMS</div>
                </div>
              </div>
              <div className="elements" ref={ref} id="users-all">
                {clients
                  .filter(value => {
                    if (search == '') {
                      return value
                    } else if (
                      value?.ccms_id?.toLowerCase()?.includes(search.toLowerCase()) ||
                      value?.ccms_name?.toLowerCase()?.includes(search.toLowerCase())
                    ) {
                      return value
                    }
                  })
                  .map((client, index) => (
                    <div className="element" key={index}>
                      <div className="client">
                        <div className="name">
                          <CheckBox2 onChange={(e) => selectForDelete(e, client)} default={false} id={`${client.ccms_id}`} text="" />
                          <h3 >{client.ccms_name}</h3>
                        </div>
                        <div className="id">
                          <h3>{client.ccms_id}</h3>
                        </div>
                      </div>
                      <div className="more">
                        <img
                          src="/icons/edit.png"
                          alt="edit"
                          onClick={() => openModal('edit', client)}
                        />
                        <img
                          src="/icons/trash.png"
                          alt="trash"
                          onClick={() => openModal('delete', client)}
                        />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="count">
                <h4>1 - {ref.current ? ref.current.children.length : 1}</h4>
              </div>
            </div>*/}

          </div>
          {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
        </div>
      </section>


      {isModalOpen.delete &&
        <ModalVw id="deleteuser-md" visible={isModalOpen.delete}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))} />
            <ModalBody clases={``} >


              {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className='modal-c'>
                <img src="/icons/alert.png" alt="" />
                <h1>{t('menu.deleteUserModal')}</h1>
                <h1>{t('menu.deleteConfirmQuestion')}</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    {t('common.cancel')}
                  </button>
                  <button onClick={onSubmitDelete} className="accept">
                    {t('common.yes')}
                  </button>
                </div>
              </div>
              {/* </Modal> */}

            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.delete_many &&
        <ModalVw id="deletemany-md" visible={isModalOpen.delete_many}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))} />
            <ModalBody clases={``} >


              {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className='modal-c'>
                <img src="/icons/alert.png" alt="" />
                <h1>{t('menu.deleteManyUserModal')}</h1>
                <h1>{t('menu.deleteConfirmQuestion')}</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    {t('common.cancel')}
                  </button>
                  <button type='button' onClick={() => deleteMultiple()} className="accept">
                    {t('common.yes')}
                  </button>
                </div>
              </div>
              {/* </Modal> */}

            </ModalBody>
          </ModalContent>
        </ModalVw>}

        {isModalOpenTypeUser.new &&
        <ModalVw id="typeuser-md" visible={isModalOpen.new} className="z-[50]" >
          <ModalContent clases={`w-auto  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#typeuser-md", () => setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false }))} />
            <ModalBody clases={``} >
              <div id="container-modal" className="addUser-modal bg-[#FAFAFA]">
                <h2 className='text-[#1C6FB0]'>{t('menu.chooseTypeUser')}</h2>
                <div id='form-type'  >
                  <div className="inputs-modal">
                    <div className="  flex flex-row items-center">

                      <input
                        name="typeu"
                        type="radio"
                        id="typeuser-1"
                        onChange={(e) => setSelectedRadio("Studio")}
                      />
                      <label htmlFor='typeuser-1' className="text-[#2E2E2E] font-bold ml-3">{t('menu.userStudio')}</label>
                    </div>
                    <div className="  flex flex-row items-center">

                      <input
                        name="typeu"
                        type="radio"
                        id="typeuser-2"
                        onChange={(e) => setSelectedRadio("TP")}
                      />
                      <label htmlFor='typeuser-2' className="text-[#2E2E2E] font-bold ml-3">{t('menu.userClient')}</label>
                    </div>
                    <div className="  flex flex-row items-center">

                      <input
                        name="typeu"
                        type="radio"
                        id="typeuser-2"
                        onChange={(e) => setSelectedRadio("GUEST")}
                      />
                      <label htmlFor='typeuser-2' className="text-[#2E2E2E] font-bold ml-3">{t('menu.guestClient')}</label>
                    </div>


                  </div>

                  <div className="buttons-modal">
                    <button
                      onClick={() => closeModalVw("#typeuser-md", () => setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false }))}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <div className="accept btn-bottom btn-bottom-create"
                      type="button"
                      onClick={(e) => { getSelectedRadioValue(e) }}
                    >
                      {t('common.select')}
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.new &&
        <ModalVw id="adduser-md" visible={isModalOpen.new} className="z-[500]" >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))} />
            <ModalBody clases={``} >
              <div id="container-modal" className="addUser-modal">
                <h2>{t('menu.addUserClientForm')}</h2>
                <form onSubmit={handleSubmit(onSubmitNew)}>
                  <div className="inputs-modal">
                    <div className="input">
                      <span>{t('common.bms')}:</span>
                      <input
                        id="ccms_id" placeholder={t('menu.specificUserId')}
                        {...register('id', { required: true, pattern: /^\d+$/ })}
                        type="text"
                      />
                    </div>
                    <div className="input">
                      <span>{t('common.ntUser')}:</span>
                      <input id="ccms_name" placeholder={t('menu.enterNtUser')} 
                       {...register('name', { required: true })} type="text" />
                    </div>
                    <div className="input">
                      <span>{t('common.maxChat')}:</span>
                      <input type='number' id="max_multichat" placeholder={t('menu.enterMaxChat')} 
                        {...register('max_multichat', { required: true })} />
                    </div>
                    <div className="input">
                      <span>{t('menu.genderAvatar')}:</span>
                      <select id="gender_avatar" {...register('gender_avatar', { required: false })}>
                        <option disabled selected>{t('common.select')}</option>
                        <option value="male">{t('common.male')}</option>
                        <option value="female">{t('common.female')}</option>
                        <option value="other">{t('common.other')}</option>
                      </select>  
                    </div>
                  </div>
                  <div className="flex items-center justify-end flex-wrap w-full">

                    <div className="upload-excel btn-excel upload-btn trans">

                      {loadingUpload ? <Loading /> : <>
                        <img src="/icons/excel.svg" alt="newAns" style={{ width: 19, marginBottom: 0 }} />
                        <label> {t('menu.uploadExcel')}</label>

                      </>}

                      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />
                    </div>
                    <div className="input " style={{ marginLeft: 10, }}>
                      <div style={{cursor: 'pointer'}}  onClick={()=>{downloadFile("FormatUsers.xlsx")}} className="a-download trans btn-excel">
                        <img src="/icons/download-icon.svg" alt="Img Template" style={{width: 15, marginRight: 5}}/>
                        {t('menu.downloadTemplate')}
                      </div>
                    </div>
                  </div>
                  <div className="buttons-modal">
                    <button
                      onClick={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <button className="accept btn-bottom btn-bottom-create" type="submit" >
                      {t('common.yes')}
                    </button>
                  </div>
                </form>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>}
     
        {isModalOpenUserStudio.new &&
        <ModalVw id="adduser-studio" visible={isModalOpen.new} className="z-[500]">
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpen, new: false }))} />
            <ModalBody clases={``} >
              <div id="container-modal" className="addUser-modal">
                <h2>{t('menu.addUserStudioForm')}</h2>
                <form onSubmit={handleSubmit(onSubmitNewStudio)}>
                  <div className="inputs-modal">
                    <div className="input">
                      <span>{t('common.bms')}:</span>
                      <input
                        id="ccms_id_studio" placeholder={t('menu.specificUserId')}
                        {...register('ccms_id_studio', { required: true, pattern: /^\d+$/ })}
                        type="text"
                      />
                    </div>
                    <div className="input">
                      <span>{t('common.ntUser')}:</span>
                      <input id="ccms_name_studio" placeholder={t('menu.enterCCMS')} 
                        {...register('ccms_name_studio', { required: true })} type="text" />
                    </div>

                    {/* <div className="input"> */}
                      <SelectNesting
                        id="role_user_studio"
                        boxInfo={false} tooltipText= {t('menu.enterRole')} 
                        title={t('menu.genai.select Role')}
                        onChange={(e) => {
                          setRoleUser(e.target.value)
                        }}
                      >
                        <option key='0' value='1'>{t('common.admin')}</option>
                        {(role == 6 || role == 5) && <option key='2' value="5">{t('common.trainer')}</option>}
                        {role == 6 && <option key='1' value='6'>{t('common.superAdmin')}</option>}
                      </SelectNesting>
                    {/* </div> */}
                  </div>
                  {/* <div className="flex items-center justify-end flex-wrap w-full">
                    <div className="upload-excel btn-excel upload-btn trans">

                      {loadingUpload ? <Loading /> : <>
                        <img src="/icons/excel.svg" alt="newAns" style={{ width: 19, marginBottom: 0 }} />
                        <label> {t('menu.uploadExcel')}</label>

                      </>}

                      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />
                    </div>
                    <div className="input " style={{ marginLeft: 10, }}>
                      <div style={{ cursor: 'pointer' }} onClick={() => { downloadFile("FormatUsersStudio.xlsx") }} className="a-download trans btn-excel"   >{t('menu.downloadTemplate')}</div>
                    </div>
                  </div> */}
                  <div className="buttons-modal">
                    <button
                      onClick={() => closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpen, new: false }))}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <button className="accept btn-bottom btn-bottom-create" type="submit" >
                      {t('common.yes')}
                    </button>
                  </div>
                </form>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>}


      {isModalOpen.edit &&
        <ModalVw id="edituser-md" visible={isModalOpen.edit}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#edituser-md", () => setIsModalOpen({ ...isModalOpen, edit: false }))} />
            <ModalBody clases={``} >
              {/* <Modal isOpen={isModalOpen.edit} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className="addUser-modal">
                <h2>{t('menu.editUserClient')} </h2>
                <form onSubmit={handleSubmit(onSubmitEdit)}>
                  <div className="inputs-modal">
                    <div className="input">
                      <span>{t('common.bms')}:</span>
                      <input
                        placeholder={t('menu.specificUserId')}
                        {...register('id', { required: true, pattern: /^\d+$/ })}
                        type="text"
                      />
                    </div>
                    <div className="input">
                      <span>{t('common.ntUser')}:</span>
                      <input placeholder={t('menu.enterNtUser')} 
                        {...register('name', { required: true })} type="text" />
                    </div>
                    <div className="input">
                      <span>{t('common.maxChat')}:</span>
                      <input type='number' id="ccms_name_edit" placeholder={t('menu.enterMaxChat')} 
                        {...register('max_multichat', { required: true })} />
                    </div>
                    <div className='input'>
                      <span>{t('menu.genderAvatar')}:</span>
                      <select id="gender_avatar_edit" {...register('gender_avatar', { required: false })}>
                        <option disabled>{t('common.select')}</option>
                        <option value="male">{t('common.male')}</option>
                        <option value="female">{t('common.female')}</option>
                        <option value="other">{t('common.other')}</option>
                      </select>  
                    </div>
                  </div>
                  <div className="buttons-modal">
                    <button
                      onClick={() => setIsModalOpen({ ...isModalOpen, edit: false })}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <button className="btn-bottom btn-bottom-create accept" type="submit">
                      {t('common.confirm')}
                    </button>
                  </div>
                </form>
              </div>
              {/* </Modal> */}
            </ModalBody>
          </ModalContent>
        </ModalVw>}
    </>
  )
}
